import React, { useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./TextEditer.css";

const TOOLTIP_LABELS = {
  "ql-bold": "Bold",
  "ql-italic": "Italic",
  "ql-underline": "Underline",
  "ql-link": "Insert Link",
  "ql-list": "List",
  "ql-header": "Header Style",
  "ql-strike": "Strikethrough",
  "ql-clean": "Clear Formatting",
};

const QuillEditor = ({
  value,
  onChange,
  onBlur,
  disabled,
  id = "quill-editor",
  className,
  error = false,
}) => {
  const errorBorder = error
    ? "1px solid rgb(239 68 68 / var(--tw-border-opacity, 1))"
    : "1px solid hsl(var(--card-border))";

  //Inject tooltip wrappers after toolbar loads
  useEffect(() => {
    const toolbar = document.querySelector(`#${id} .ql-toolbar`);
    if (!toolbar) return;

    const buttons = toolbar.querySelectorAll("button, select");

    buttons.forEach((btn) => {
      const classes = btn.className.split(" ");
      const qlClass = classes.find((c) => c.startsWith("ql-"));

      const label = TOOLTIP_LABELS[qlClass];
      if (!label) return;

      // avoid double-wrapping
      if (btn.parentElement.classList.contains("ql-tooltip-wrapper")) return;

      const wrapper = document.createElement("div");
      wrapper.className = "ql-tooltip-wrapper inline-flex items-center";

      // Replace button → inside wrapper
      btn.parentNode.insertBefore(wrapper, btn);
      wrapper.appendChild(btn);

      //Apply data-tooltip attribute for your CustomTooltip
      wrapper.setAttribute("data-tooltip", label);
    });
  }, [id]);

  return (
    <div className="rounded-md">
      <ReactQuill
        theme="snow"
        id={id}
        className={className}
        readOnly={disabled}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
      <style>
        {`
          #${id} .ql-toolbar.ql-snow,
          #${id} .ql-container.ql-snow {
            background-color: hsl(var(--primary-foreground));
            border: ${errorBorder};
          }
        `}
      </style>
    </div>
  );
};

// const RootStyle = styled("div")(({ theme,error }) => ({
// 	borderRadius: theme.shape.borderRadius,
// 	"& .ql-container.ql-snow": {
// 		borderColor: error ? 'hsl(var(--destructive))' : 'hsl(var(--border))',
// 		...theme.typography.body1,
// 	},
// 	"& .ql-toolbar.ql-snow": {
// 		border: `solid 1px ${error ? 'hsl(var(--destructive))' : 'hsl(var(--border))'}`,
// 		backgroundColor: theme.palette.background.primary,
// 	},
// 	"& .ql-toolbar.ql-snow .ql-picker-label": {
// 		color: theme.palette.text.primary,
// 	},
// 	"& .ql-snow .ql-stroke": {
// 		stroke: theme.palette.text.primary,
// 	},
// 	"& .ql-editor": {
// 		minHeight: 200,
// 		backgroundColor: theme.palette.background.primary,
// 		borderRadius: '12px',
// 		"&.ql-blank::before": {
// 			fontStyle: "normal",
// 			color: theme.palette.text.primary,
// 		},
// 		"& pre.ql-syntax": {
// 			...theme.typography.body2,
// 			padding: theme.spacing(2),
// 			borderRadius: theme.shape.borderRadius,
// 		},
// 	},
// }));

export default QuillEditor;
